










































import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { Activity } from '@/interfaces'

@Component
export default class EditActivityDialog extends Vue {
  @Watch('dateValue')
  onDateValueChanged (date: string) {
    this.dateValueFormatted = this.formatDate(date)
    this.activity.created = moment(this.dateValue).valueOf()
  }

  activity: Activity = { id: '', created: 0, notes: '' }
  dateMenu: any = false
  dateValue: string = new Date().toISOString().substr(0, 10)
  dateValueFormatted: string = this.formatDate(this.dateValue)
  dialog: boolean = false

  formatDate (date: any): string {
    if (!date) return ''

    const [year, month, day] = date.split('-')

    return `${month}/${day}/${year}`
  }

  open (activityId?: string) {
    if (activityId) {
      this.activity = this.$store.state.activities.loaded[activityId]
      this.dateValue = moment(this.activity.created).toISOString().substr(0, 10)
    }

    this.dialog = true
  }

  save () {
    this.$store.dispatch('activities/save', this.activity)

    this.dialog = false
  }
}
